import { Injectable } from '@angular/core';
import {BehaviorSubject, catchError, Observable, tap, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SharedDataService} from "./shared-data.service";
import {environment} from "../../environments/environment";
import {GiiAtaskaitaApi} from '../api/gii-ataskaita.api';
import {GiiAtaskVertinimasApi} from '../api/gii-atask-vertinimas.api';

@Injectable({
  providedIn: 'root',
})
export class AtaskPerziuraService {
  private fetchGiiAtaskUrl = environment.apiBaseUrl + '/internalApi/giiAtaskaita/';
  private createAtaskVertinimasUrl = environment.apiBaseUrl + '/internalApi/ataskaitosVertinimas';
  private priskirtiAsmeniUrl = environment.apiBaseUrl + '/internalApi/priskirtiAsmeni';
  private ataskPerziuraSubject = new BehaviorSubject<{ selectedId: number; regId: number; srautoKodas: string; ataskLaikotarpis: string } | null>(null);
  ataskPerziura$ = this.ataskPerziuraSubject.asObservable();

  constructor(private http: HttpClient,
              private sharedDataService: SharedDataService) {}

  fetchGiiAtaskaitaById(ataskId: number): Observable<GiiAtaskaitaApi> {
    let url = this.fetchGiiAtaskUrl + ataskId;
    return this.http.get<GiiAtaskaitaApi>(url, { withCredentials: true }).pipe(
      catchError((error) => {
        this.sharedDataService.setKlaidos(error.error);
        return throwError(error);
      })
    );
  }

  sukurtiAtaskaitosVertinima(ataskVertinimasApi: GiiAtaskVertinimasApi): Observable<GiiAtaskaitaApi> {
    return this.http.post<GiiAtaskaitaApi>(this.createAtaskVertinimasUrl, ataskVertinimasApi, {withCredentials: true});
  }

  priskirtiAsmeni(ataskVertinimasApi: GiiAtaskVertinimasApi): Observable<GiiAtaskaitaApi> {
    return this.http.post<GiiAtaskaitaApi>(this.priskirtiAsmeniUrl, ataskVertinimasApi, {withCredentials: true});
  }

  openAtaskPerziura(row: any): void {
    this.ataskPerziuraSubject.next({selectedId: row.id, regId: row.regId, srautoKodas: row.srautoKodas, ataskLaikotarpis: row.ataskLaikotarpis});
  }

  closePerziura() {
    this.ataskPerziuraSubject.next(null);
  }
}
